import React, { useCallback } from "react";
import { Send } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { getNextQueryParams } from "components/helpers";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import useAuthorized from "hooks/useAuthorized";
import ConstantContactCampaignsService from "services/ConstantContactCampaigns";
import CampaignActivityModal from "routes/constant_contact/components/CampaignActivityModal";
import {
  invalidateCampaignActivitiesQuery,
  useCampaignActivityTable,
} from "hooks/useCampaignActivityTable";

export const CAMPAIGN_ACTIVITY_TABLE_CONSTANTS = {
  tableName: "campaignActivities",
  queryKey: "campaign-activities",
  className: "CampaignActivity",
  exportTableName: null,
  header: "Constant Contact Campaigns",
  headerIcon: Send,
};

const CampaignActivityTableV3 = () => {
  const { columns } = useCampaignActivityTable();
  const canCreate = useAuthorized([
    ACL_RELATIONSHIPS.constantContactCampaigns.create,
  ]);

  const fetchCampaignActivities = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response =
          await ConstantContactCampaignsService.getCampaignActivities(
            nextQueryParams
          );

        return response;
      } catch (error) {
        console.error("Error fetching campaign activities:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      queryKey={CAMPAIGN_ACTIVITY_TABLE_CONSTANTS.queryKey}
      tableName={CAMPAIGN_ACTIVITY_TABLE_CONSTANTS.tableName}
      header={CAMPAIGN_ACTIVITY_TABLE_CONSTANTS.header}
      headerIcon={CAMPAIGN_ACTIVITY_TABLE_CONSTANTS.headerIcon}
      createButton={canCreate ? <CampaignActivityModal /> : null}
      fetchData={fetchCampaignActivities}
      invalidateData={invalidateCampaignActivitiesQuery}
      enableSettings
      enableSearch
    />
  );
};

export default CampaignActivityTableV3;
